import { Component, OnInit, AfterViewChecked, Output, EventEmitter } from '@angular/core';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-numberpad',
  templateUrl: './numberpad.component.html',
  styleUrls: ['./numberpad.component.css']
})
export class NumberpadComponent implements OnInit {

 

  @Output() editChanged = new EventEmitter<any>();
  @Output() deleteChanged = new EventEmitter<any>();


  constructor() { }


  ngOnInit() {
 
  }
  fnEditBtnClick(pBO) {
  
    this.editChanged.emit(pBO)
  }
  fnDeleteBtnClick(pBO) {

    this.deleteChanged.emit(pBO)

  }
  }

 




